import { render, staticRenderFns } from "./InvoiceWrite.vue?vue&type=template&id=72d2b48b&scoped=true&"
import script from "./InvoiceWrite.vue?vue&type=script&lang=js&"
export * from "./InvoiceWrite.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceWrite.vue?vue&type=style&index=0&id=72d2b48b&lang=less&scoped=true&"
import style1 from "./InvoiceWrite.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2b48b",
  null
  
)

export default component.exports